import axios from "axios";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(
  /\/$/,
  "",
);

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// API service functions
export const fetchProviderList = () => {
  return api.get("/gamelogin/getcategorie");
};

export const fetchProvidersByCategory = (categoryCode) => {
  return api.get(`/gamelogin/getprovider/${encodeURIComponent(categoryCode)}`);
};

export default api;
